import { InfoCircleOutlined } from '@ant-design/icons';
import TcModal from 'components/UI/Modal/TcModal';
import TcTab, { TabsProp } from 'components/UI/Tab/TcTab';
import TcCoverLoading from 'components/UI/TcLoading/TcCoverLoading';
import ReservedLockerContent from 'components/pages/dashboard/ParcelOrder/components/orderAddressPicker/compoonents/reservedLockerContent';
import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import lockerModel, { userAccessibleLKiosk } from 'global/Models/lockerModel';
import { lockerInfo, packageCreate } from 'global/Models/omOrderModel';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { setOmOrderReservedByLocker } from 'redux/reducer/ParcelOrder/parcelOrderReducer';
import { RootState, store } from 'redux/store';
import OrderSelectLockerListOnMap from './OrderSelectLockerListOnMapTab';
import OrderSelectLockerListTab from './OrderSelectLockerListTab';

interface IProps {
  setLockerAddress?: (_locker: lockerInfo) => void;
  packages: packageCreate[] | undefined;
  index: number;
  visible?: number;
  close: () => void;
  lockerAddress?: lockerInfo;
}

const OrderSelectLocker: FC<IProps> = ({ packages, setLockerAddress, visible, close, lockerAddress, index }) => {
  //state
  const [errorMsg, setErrorMsg] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const [tab, setTab] = useState<'kioskList' | 'kioskListOnMap'>('kioskListOnMap');
  const [userAccessibleKiosksList, setUserAccessibleKiosksList] = useState<IBackendGetGeneric<userAccessibleLKiosk>>();
  const omOrderReservedByLocker = useSelector((state: RootState) => state.parcelOrder.omOrderReservedByLocker);
  // const [selectedCityId, setSelectedCityId] = useState<number>();
  // const [latLong, setLatLong] = useState<latLong>({
  //   lat: undefined,
  //   long: undefined,
  // });

  //effect
  useEffect(() => {
    if (!visible) return;
    getUserAccessibleKiosks(visible);
  }, [visible]);

  const tabs: TabsProp[] = [];

  !lockerAddress &&
    userAccessibleKiosksList &&
    tabs.push({
      content: (
        <OrderSelectLockerListOnMap
          cityId={visible}
          packages={packages}
          loading={loading}
          userAccessibleKiosksList={userAccessibleKiosksList}
          setLockerAddress={setLockerAddress}
          index={index}
        />
      ),
      title: lockerModel.KioskListOnMapTitle,
      key: 'kioskListOnMap',
    });

  !lockerAddress &&
    userAccessibleKiosksList &&
    tabs.push({
      content: (
        <OrderSelectLockerListTab
          userAccessibleKiosksList={userAccessibleKiosksList}
          packages={packages}
          visible={visible}
          loading={loading}
          setLockerAddress={setLockerAddress}
          index={index}
        />
      ),
      title: lockerModel.KioskListTitle,
      key: 'kioskList',
    });

  //functions
  const getUserAccessibleKiosks = async (visible: number) => {
    setLoading(true);
    // const pack = packages ? packages[index] : ({} as packageCreate);
    // How It Works:
    // The code iterates over each package in the pack array, creating objects with dimensions and weight. If count is 1, a single object is added; otherwise, multiple objects are added based on count.
    // const payload = {
    //   lockerDimensions: pack.package.flatMap((pkg) => {
    //     const { width, height, length, weight, count } = pkg;
    //     if (!count || count < 2) {
    //       return [{ width, height, length, weight }];
    //     } else {
    //       return Array.from({ length: count }, () => ({ width, height, length, weight }));
    //     }
    //   }),
    // };
    const payload: any = {};
    if (packages?.length) {
      payload.lat = packages[0].receiverAddress?.address.latitude;
      payload.lon = packages[0].receiverAddress?.address.longitude;
    } else {
      payload.cityId = visible;
    }
    await ApiService.post(endpointUrls.lockerSearchBunch, payload)
      .then((res: IBackendGetGeneric<userAccessibleLKiosk>) =>
        handleApiThenGeneric<IBackendGetGeneric<userAccessibleLKiosk>, userAccessibleLKiosk>({
          res,
          onSuccess: setUserAccessibleKiosksList,
          notifFail: false,
          notifSuccess: false,
          onFailed: () => {
            setErrorMsg(res.message || 'خطا در دریافت اطلاعات');

            setUserAccessibleKiosksList(undefined);
          },
        })
      )
      .catch(() => localApiCatcher(errorResponse));
    setLoading(false);
  };

  const handleTabChange = (tab: 'kioskList' | 'kioskListOnMap') => setTab(tab);

  const handleClose = () => {
    setTab('kioskListOnMap');
    setErrorMsg(undefined);
    store.dispatch(setOmOrderReservedByLocker(undefined));
    setUserAccessibleKiosksList(undefined);

    close();
  };

  return (
    <TcModal title='انتخاب کیوسک جهت رزرو' className='h-4/5!' visible={!!visible} width={errorMsg ? 500 : 1000} onCancel={handleClose} footer={false}>
      {!omOrderReservedByLocker && !errorMsg && (
        <div className='flex items-center py-4 font-medium'>
          <InfoCircleOutlined className='ml-1 text-lg inherit-color text-t-error-color' />
          توجه کنید که تنها تا ۵ دقیقه پس از رزرو فرصت ثبت سفارش دارید و پس از آن امکان پرشدن کیوسک هست.
        </div>
      )}

      {loading && <TcCoverLoading text='درحال دریافت لیست کیوسک های در محدوده ی شما' />}
      {!lockerAddress && userAccessibleKiosksList && <TcTab tabs={tabs} onChange={handleTabChange} activeTab={tab} />}

      <ReservedLockerContent orderReservationData={omOrderReservedByLocker} />

      {errorMsg && <span>{errorMsg}</span>}
      {/* <div className='p-4 border rounded-xl'> */}
      {/* <TcForm form={form} onFinish={getUserAccessiblekiosks}> */}
      {/* <div className='flex'>
            <InfoCircleOutlined className='ml-1' />
            <span className='text-sm'>شهر مقصد را جهت یافتن کیوسک های در محدوده خود انتخاب کنید.</span>
          </div>
          <TcFormWrapper>
            <TcFormItem label='شهر' name='cityId' rules={[{ required: true, message: 'شهر را وارد کنید' }]}>
              <TcSelectReduxSearch reducerName='city' reducerListProperty='allCitiesWithoutSearch' getlist={getAllCitiesWithoutSearch} prefixLabelPropertyName='provinceTitle' />
            </TcFormItem>
          </TcFormWrapper> */}
      {/* user packages    */}
      {/* <div className='mt-5'>
            <div className='flex items-center w-full gap-1 mb-2 text-xs color-inherit text-t-primary-color'>
              <BsBoxSeam />
              <span className='text-sm font-semibold text-t-primary-color'>بسته های شما</span>
            </div>
            <div className='flex mt-1 gap-x-2'>{renderPackages}</div>
          </div> */}
      {/* user packages    */}
      {/* <div className='flex items-center justify-end h-full mt-2'>
            <TcButton loading={loading} size='middle' type='primary' htmlType='submit'>
              جستجوی کیوسک
            </TcButton>
          </div> */}
      {/* </TcForm> */}
      {/* </div> */}
      {/* userAccessibleKiosksList in table  */}
    </TcModal>
  );
};

export default OrderSelectLocker;
